import type { ReactNode } from 'react';
import { cn } from '../lib/cn';

export type AlertVariant = 'info' | 'success' | 'warning' | 'error';

const VARIANT: Record<AlertVariant, string> = {
  info: 'border-neutral-300 bg-neutral-50 text-yhelp-black dark:border-neutral-700 dark:bg-neutral-900 dark:text-neutral-100',
  success:
    'border-status-resolvido bg-green-50 text-yhelp-black dark:border-green-800 dark:bg-green-950 dark:text-green-100',
  warning:
    'border-sla-warning bg-amber-50 text-yhelp-black dark:border-amber-800 dark:bg-amber-950 dark:text-amber-100',
  error:
    'border-priority-critico bg-red-50 text-yhelp-black dark:border-red-800 dark:bg-red-950 dark:text-red-100',
};

export interface AlertProps {
  variant?: AlertVariant;
  title: string;
  children?: ReactNode;
  className?: string;
}

export function Alert({ variant = 'info', title, children, className }: AlertProps) {
  return (
    <div
      role="alert"
      className={cn('rounded-xl border px-4 py-3 text-sm', VARIANT[variant], className)}
    >
      <p className="font-semibold">{title}</p>
      {children ? (
        <div className="mt-1 text-neutral-700 dark:text-neutral-300">{children}</div>
      ) : null}
    </div>
  );
}
